import { ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import styles from './index.module.css';

interface Props {
  children: ReactNode;
  content: string;
  align?: 'start' | 'center' | 'end';
  conditional?: boolean;
}

export function Tooltip(props: Props) {
  const { children, content, align, conditional = true } = props;

  if (!conditional) {
    return children;
  }

  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Content className={styles.content} sideOffset={4} align={align}>
        <span>{content}</span>
        <TooltipPrimitive.Arrow className={styles.arrow} />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Root>
  );
}
